import { Link } from "react-router-dom";
import SEOHead from "@/components/SEOHead";
import { MapPin, Phone, ArrowRight, Star, MessageCircle } from "lucide-react";
import ScrollReveal from "@/components/ScrollReveal";
import QuoteForm from "@/components/QuoteForm";
import HeroPremium from "@/components/HeroPremium";

const regions = [
  {
    name: "Bruxelles", desc: "16 communes de la Région de Bruxelles-Capitale",
    communes: [
      { name: "Anderlecht", slug: "anderlecht" }, { name: "Auderghem", slug: "auderghem" },
      { name: "Etterbeek", slug: "etterbeek" }, { name: "Evere", slug: "evere" },
      { name: "Forest", slug: "forest" }, { name: "Ganshoren", slug: "ganshoren" },
      { name: "Ixelles", slug: "ixelles" }, { name: "Jette", slug: "jette" },
      { name: "Koekelberg", slug: "koekelberg" }, { name: "Molenbeek", slug: "molenbeek" },
      { name: "Saint-Gilles", slug: "saint-gilles" }, { name: "Schaerbeek", slug: "schaerbeek" },
      { name: "Uccle", slug: "uccle" }, { name: "Watermael-Boitsfort", slug: "watermael-boitsfort" },
      { name: "Woluwe-Saint-Lambert", slug: "woluwe-saint-lambert" }, { name: "Woluwe-Saint-Pierre", slug: "woluwe-saint-pierre" },
    ]
  },
  {
    name: "Brabant flamand", desc: "Principales communes du Brabant flamand",
    communes: [
      { name: "Vilvorde", slug: "vilvorde" }, { name: "Hal (Halle)", slug: "hal" },
      { name: "Zaventem", slug: "zaventem" }, { name: "Tervuren", slug: "tervuren" },
      { name: "Overijse", slug: "overijse" }, { name: "Grimbergen", slug: "grimbergen" },
      { name: "Asse", slug: "asse" }, { name: "Dilbeek", slug: "dilbeek" },
      { name: "Sint-Pieters-Leeuw", slug: "sint-pieters-leeuw" }, { name: "Leuven", slug: "leuven" },
    ]
  },
  {
    name: "Brabant wallon", desc: "Principales communes du Brabant wallon",
    communes: [
      { name: "Wavre", slug: "wavre" }, { name: "Nivelles", slug: "nivelles" },
      { name: "Ottignies", slug: "ottignies" }, { name: "Braine-l'Alleud", slug: "braine-lalleud" },
      { name: "Waterloo", slug: "waterloo" }, { name: "La Hulpe", slug: "la-hulpe" },
      { name: "Tubize", slug: "tubize" }, { name: "Rebecq", slug: "rebecq" },
    ]
  }
];

export default function ZonesIntervention() {
  return (
    <div data-testid="zones-page" style={{ backgroundColor: '#fff', color: '#1a1a1a' }}>
      <SEOHead title="Zones d'intervention | VGI Construct – Bruxelles, Brabant flamand et Brabant wallon" description="VGI Construct intervient dans plus de 35 communes : Bruxelles-Capitale, Brabant flamand et Brabant wallon. Ixelles, Uccle, Anderlecht, Waterloo, Wavre, Vilvorde… Devis gratuit – réponse sous 48 h." path="/zones-intervention" />

      {/* HERO PREMIUM NOIR */}
      <HeroPremium
        badge="Notre zone"
        titleWhite="Nous venons"
        titleRed="chez vous"
        photo="https://images.unsplash.com/photo-1726577488536-081e16b3b892?w=700&q=85"
        photoAlt="Vue aérienne de Bruxelles"
        photoBadgeIcon={MapPin}
        photoBadgeTitle="35+ Communes"
        photoBadgeSub="couvertes"
        decoNumber="06"
      />

      {/* CARTE GOOGLE MAPS */}
      <section style={{ backgroundColor: '#f8f8f8', padding: '48px 0' }}>
        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
          <div style={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 24px rgba(0,0,0,0.06)', border: '1px solid #e8e8e8' }}>
            <iframe title="Zones d'intervention VGI Construct"
              src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d323542.4!2d4.35!3d50.75!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sfr!2sbe!4v1"
              width="100%" height="400" style={{ border: 0 }} allowFullScreen="" loading="lazy" />
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '16px', marginTop: '28px' }}>
            {regions.map(r => (
              <div key={r.name} style={{ display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#fff', border: '1px solid #e0e0e0', padding: '12px 20px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                <MapPin size={18} color="#8B0000" />
                <span style={{ color: '#1a1a1a', fontWeight: 800, fontSize: '14px' }}>{r.name}</span>
                <span style={{ color: '#888', fontSize: '12px' }}>({r.communes.length} communes)</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* REGIONS */}
      {regions.map((region, idx) => (
        <section key={region.name} style={{ backgroundColor: idx % 2 === 0 ? '#ffffff' : '#f8f8f8', padding: '64px 0' }}>
          <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
            <ScrollReveal>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '8px' }}>
                <div style={{ width: '10px', height: '10px', backgroundColor: '#8B0000', borderRadius: '50%' }} />
                <p style={{ textTransform: 'uppercase', fontSize: '12px', letterSpacing: '0.2em', fontWeight: 700, color: '#8B0000', margin: 0 }}>{region.name}</p>
              </div>
              <h2 style={{ fontFamily: "'Cabinet Grotesk', sans-serif", fontSize: 'clamp(1.8rem, 3vw, 2.5rem)', fontWeight: 900, color: '#1a1a1a', marginBottom: '8px' }}>{region.name}</h2>
              <p style={{ color: '#666', fontSize: '16px', marginBottom: '36px' }}>{region.desc}</p>
            </ScrollReveal>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '12px' }}>
              {region.communes.map((commune, i) => (
                <ScrollReveal key={commune.name} delay={i * 30}>
                  <Link to={`/travaux-${commune.slug}`} data-testid={`zone-${commune.slug}`} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '14px 16px', backgroundColor: idx % 2 === 0 ? '#f8f8f8' : '#fff', border: '1px solid #e8e8e8', borderRadius: '8px', textDecoration: 'none', transition: 'all 0.3s' }}>
                    <MapPin size={16} color="#8B0000" />
                    <span style={{ color: '#1a1a1a', fontSize: '14px', fontWeight: 600 }}>{commune.name}</span>
                  </Link>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </section>
      ))}

      {/* CTA */}
      <section style={{ backgroundColor: '#f8f8f8', padding: '64px 0' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '0 24px', textAlign: 'center' }}>
          <ScrollReveal>
            <h2 style={{ fontFamily: "'Cabinet Grotesk', sans-serif", fontSize: 'clamp(1.8rem, 3vw, 2.5rem)', fontWeight: 900, color: '#1a1a1a', marginBottom: '16px' }}>Demandez votre devis gratuit</h2>
            <p style={{ color: '#666', fontSize: '16px', marginBottom: '32px' }}>Intervention dans toute la région — Devis gratuit – réponse sous 48 h</p>
          </ScrollReveal>
          <ScrollReveal delay={200}><QuoteForm /></ScrollReveal>
        </div>
      </section>

      {/* Schema.org */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org", "@type": "GeneralContractor", "name": "VGI Construct",
        "description": "Entreprise de construction et rénovation à Bruxelles, Brabant flamand et Brabant wallon.",
        "telephone": "+32466407988", "email": "info@vgiconstruct.be",
        "address": { "@type": "PostalAddress", "streetAddress": "Bergensesteenweg 24/8", "addressLocality": "Sint-Pieters-Leeuw", "postalCode": "1600", "addressCountry": "BE" },
        "areaServed": [
          { "@type": "AdministrativeArea", "name": "Bruxelles-Capitale" },
          { "@type": "AdministrativeArea", "name": "Brabant flamand" },
          { "@type": "AdministrativeArea", "name": "Brabant wallon" }
        ], "openingHours": "Mo-Fr 08:00-18:00"
      })}} />
    </div>
  );
}
